<template>
    <v-app class="white">
    <div class="main_top">
        <!-- 제목 -->
        <div class="top_title_text">{{ $t('qrcode') }}</div> 
            <!-- 옵션메뉴 -->
            <div class="btn-option-menu" 
            v-ripple="{ center: true, class: `teal--text`  }"
            @click.passive="onClickBack">
                <v-img 
                class="img-option-back"
                ma-0
                pa-0
                transition="false"
                :src="require('../assets/backkey.png')">
                </v-img>
            </div>
        </div>
        <div class="top_line"></div>
        <div class="camera-postion">
            <qrcode-stream @decode="onDecode" @init="onInit" />
        </div>
    </v-app>

</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

export default {

  components: { QrcodeStream },
  created() {
      var handleSuccess = function(stream) {
          console.log("handleSuccess")
      };
      navigator.mediaDevices.getUserMedia({video: true})
      .then(handleSuccess);
  },
  data () {
    return {
      result: '',
      error: '',
    }
  },
  methods: {
    onDecode (result) {
        this.result = result
        this.$EventBus.$emit('qrcode_reader_result', result);
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    },
    onClickBack : function() {
        console.log("onClickBack")
        this.$EventBus.$emit('qrcode_reader_result', "");
    }
  }
}
</script>

<style scoped>
.error {
    font-weight: bold;
    color: red;
}
.main_top {
    position: absolute;
    height: 7.1vh;
    width: 100vw;
    display: inline-block;
    top: 0vh;
}
  .top_title_text {
    color: #075a81;
    text-align: center;
    width: 100vw;
    right: 0vw;
    font-size: 3.9vw;
    display: inline-block;
    position: absolute;
    top: 4.12vw;
    font-weight: bold;
  }
.btn-option-menu {
    position: absolute;
    width: 15vw;
    height: 13vw;
    top: 0vw;
    left: 0vw;
  }
.img-option-back {
    position: absolute;  
    top: 3.2vw;
    left: 5vw;        
    width: 2.7vw;
    height: 5.1vw;  
  }
.top_line {
    position: absolute;
    width: 100vw;
    height: 1px;
    top: 12.62vw;
    left: 0vw; 
    background-color: #1b6aad;
  }
.camera-postion {
    position: absolute;
    width: auto;
    height: auto;
    top: 12.7vw;
    left: 0vw; 
    right: 0vw;
    bottom: 0vw;
  }
</style>